import React, { useState, useContext, useEffect } from "react";
import {
  Grid,
  Box,
  Button,
  Typography,
  CircularProgress
} from "@material-ui/core";
import WizardStep from "../../components/WizardStep/WizardStep";
import PageTitle from "../../components/PageTitle/PageTitle";
import { FormattedMessage } from "react-intl";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Redirect, useParams } from "react-router-dom";
import Lottie from "react-lottie";
import * as animationData from "../../assets/lottie/lf30_editor_3lwHSL.json";
import { GeneralContext } from "../../contexts/GeneralContext";
import {
  getGuestAppUrl,
  requestGuestAppClaim
} from "../../services/GuestAppService";
import { trimTrailingSlashes } from "../../helpers/guestApp";
import { clearDrafts } from "../../helpers/session";

const Finish = () => {
  const { cid } = useParams();
  const { BookingReady, LngLink, CIDData } = useContext(GeneralContext);
  const [RedirectOn, setRedirectOn] = useState();
  const [GuestAppUrl, setGuestAppUrl] = useState(null);
  const [OpeningApp, setOpeningApp] = useState(false);
  const companyId = CIDData && CIDData.empresa;

  // Check-in terminado: los borradores locales (datos de pax y firma) ya no
  // hacen falta y no deben quedar en el dispositivo.
  useEffect(() => {
    if (cid) clearDrafts(cid);
  }, [cid]);

  useEffect(() => {
    let active = true;
    getGuestAppUrl(companyId).then(url => {
      if (active) setGuestAppUrl(url);
    });
    return () => {
      active = false;
    };
  }, [companyId]);

  // Spec 086: pedir el código de canje recién en el click (vive 2 min). Si
  // falla por lo que sea, se navega a la app sin sesión, como antes.
  const openGuestApp = () => {
    if (OpeningApp) return;
    setOpeningApp(true);
    requestGuestAppClaim().then(claimUrl => {
      window.location.href = claimUrl
        ? `${trimTrailingSlashes(process.env.REACT_APP_GUEST_APP_URL)}${claimUrl}`
        : GuestAppUrl;
    });
  };

  // Al volver con "atrás" desde Huésped+, el bfcache (Safari iOS, Chrome
  // mobile) restaura esta página con el estado de React intacto y `OpeningApp`
  // quedaría en true: rehabilitamos el botón para que se pueda reintentar.
  useEffect(() => {
    const onPageShow = e => {
      if (e.persisted) setOpeningApp(false);
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
  };

  return (
    <Grid container>
      <Grid item xs={12} style={{ width: "100%" }}>
        <WizardStep activeStep={3} />
      </Grid>
      <Grid item xs={12}>
        <Box
          p={2}
          pt={0}
          pb={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Lottie
            options={defaultOptions}
            height={300}
            width={300}
            isStopped={false}
            isPaused={false}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <PageTitle
          pt={0}
          title="finish.title"
          description="finish.description"
        />
      </Grid>
      <Grid item xs={12}>
        <Box p={3} pt={0} pb={1}>
          <Typography variant="body2" align="center" color="primary">
            <FormattedMessage id="finish.body2" />
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box p={2} pt={1} pb={1}></Box>
      </Grid>
      <Grid item xs={12} className="ButtonWrapper">
        <Box p={2} pt={1} pb={4}>
          {GuestAppUrl ? (
            <Box mb={2}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={openGuestApp}
                disabled={OpeningApp}
                fullWidth
                endIcon={
                  OpeningApp ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <ChevronRightIcon />
                  )
                }
              >
                <FormattedMessage id="finish.openGuestApp" />
              </Button>
            </Box>
          ) : null}
          <Button
            variant={GuestAppUrl ? "outlined" : "contained"}
            color="primary"
            size="large"
            onClick={() => setRedirectOn(true)}
            fullWidth
            endIcon={<ChevronRightIcon />}
          >
            <FormattedMessage id="finish.exit" />
          </Button>
        </Box>
      </Grid>
      {!BookingReady.find((cidN) => cidN == cid) || RedirectOn ? (
        <Redirect
          push
          to={`${LngLink + process.env.REACT_APP_ROOT_PATH_LINK}/`}
        />
      ) : null}
    </Grid>
  );
};

export default Finish;
